import React, { useContext, useEffect, useState } from "react";

import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import VisibilityIcon from "@material-ui/icons/Visibility";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import EventBusyIcon from "@material-ui/icons/EventBusy";
import AccessAlarmsIcon from "@material-ui/icons/AccessAlarms";
import RefreshIcon from "@material-ui/icons/Refresh";
import Tooltip from "@material-ui/core/Tooltip";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";

import TableDefault from "../../components/grid/TableDefault";

import { findCNDAgendaCliente } from "../../repository/ERP/pub/CNDAgendaClienteService";
import MaskService from "../../utils/mask/maskService";
import { QueryParamsContext } from "../../context/QueryParamsContext";
import { notify } from "../../utils/notify";
import { findCNDConfig } from "../../repository/ERP/pub/CNDConfigService";
import { findClienteByCpfCnpj } from "../../repository/ERP/prouser/ClienteService";
import "./CND.css";

const defaultTableColumns = [
  {
    id: "acoes",
    label: "Ações",
    align: "center",
  },
  {
    id: "cnpj_cpf",
    label: "Nº Inscrição",
  },
  {
    id: "razao",
    label: "Razão Social",
  },
  { id: "total", label: "Total", align: "center" },
];

const CNDTabControleCliente = ({ rowsPerPage }) => {
  const [dataRows, setDataRows] = useState([]);
  const [loadingData, setLoadingData] = useState(false);
  const [refreshData, setRefreshData] = useState(false);
  const [runTimeout, setRunTimeout] = useState(false);
  const [idCliente, setIdCliente] = useState(null);
  const [access, setAccess] = useState(false);
  const { queryParams } = useContext(QueryParamsContext);

  useEffect(() => {
    setRunTimeout(true);

    if (runTimeout) return;

    setTimeout(() => {
      setRunTimeout(false);

      setRefreshData((current) => !current);
    }, 300000);
  }, [refreshData, runTimeout]);

  useEffect(() => {
    if (idCliente || !queryParams.cliente_cnpj) return;

    (async () => {
      try {
        setLoadingData(true);
        const result = await findClienteByCpfCnpj(
          queryParams.empresa_cnpj,
          queryParams.cliente_cnpj
        );

        if (result && result.data) {
          setIdCliente(result.data.id || null);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoadingData(false);
      }
    })();
  }, [queryParams.cliente_cnpj, queryParams.empresa_cnpj, idCliente]);

  useEffect(() => {
    (async () => {
      try {
        setLoadingData(true);
        const result = await findCNDConfig(
          queryParams.empresa_cnpj,
          "acesso_cliente_qyon_pass"
        );

        if (result.success && result.data && result.data.value) {
          setAccess(true);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoadingData(false);
      }
    })();
  }, [queryParams.empresa_cnpj]);

  useEffect(() => {
    if (!access || !idCliente) return;
    try {
      const columnsSubitem = [
        {
          id: "acoes",
          label: "Ações",
          align: "center",
        },
        {
          id: "ambito",
          label: "Âmbito",
        },
        {
          id: "cnd",
          label: "Certidão",
        },
        { id: "consulta", label: "Consulta", align: "center" },
        { id: "icon", label: "Situação", align: "center" },
        {
          id: "data_emissao",
          label: "Emissão",
          align: "center",
        },
        {
          id: "data_vencimento",
          label: "Vencimento",
          align: "center",
        },
      ];

      const showFile = (file) => {
        if (!file || typeof file !== "string" || file.indexOf("data:") === -1) {
          return;
        }

        const contentType = file.substring(
          file.split("").findIndex((e) => e === ":") + 1,
          file.split("").findIndex((e) => e === ";")
        );

        const byteCharacters = atob(
          file.substr(`data:${contentType};base64,`.length)
        );

        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
          const slice = byteCharacters.slice(offset, offset + 1024);

          const byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }

          const byteArray = new Uint8Array(byteNumbers);

          byteArrays.push(byteArray);
        }
        const blob = new Blob(byteArrays, { type: contentType });
        const blobUrl = URL.createObjectURL(blob);

        window.open(blobUrl, "_blank");
      };

      const downloadFile = (file) => {
        if (!file || typeof file !== "string") return;

        try {
          var element = document.createElement("a");

          element.setAttribute(
            "href",
            "data:application/octet-stream;base64," +
              encodeURIComponent(
                file.substring(file.split("").findIndex((e) => e === ",") + 1)
              )
          );

          element.setAttribute(
            "download",
            `CND.${file.substring(
              file.split("").findIndex((e) => e === "/") + 1,
              file.split("").findIndex((e) => e === ";")
            )}`
          );

          element.style.display = "none";
          document.body.appendChild(element);

          element.click();

          document.body.removeChild(element);

          return true;
        } catch (error) {
          console.error("ERROR ButtonsAccountant executeDownload:", error);
          return false;
        }
      };

      const mapAllFiles = (items, option) => {
        if (!items || !option) return;

        const optionsFunctions = {
          show: showFile,
          download: downloadFile,
        };

        items.map((item) => {
          optionsFunctions[option](item.file_base64);
          return null;
        });
      };

      const constructorRows = async () => {
        let dataRowsCopy = [];

        const optionsIcons = {
          "Positiva Negativa": (
            <Tooltip title="Positiva com efeitos de Negativa">
              <CheckCircleIcon className="color-green" />
            </Tooltip>
          ),
          "Positiva NegativaaVencer": (
            <Tooltip title="Positiva com efeitos de Negativa a vencer">
              <AccessAlarmsIcon className="color-green" />
            </Tooltip>
          ),
          "Positiva NegativaVencida": (
            <Tooltip title=" Positiva com efeitos de Negativa vencida">
              <EventBusyIcon className="color-green" />
            </Tooltip>
          ),
          Negativa: (
            <Tooltip title="Negativa">
              <CheckCircleIcon className="color-green" />
            </Tooltip>
          ),
          NegativaaVencer: (
            <Tooltip title="Negativa a vencer">
              <AccessAlarmsIcon className="color-green" />
            </Tooltip>
          ),
          NegativaVencida: (
            <Tooltip title="Negativa vencida">
              <EventBusyIcon className="color-green" />
            </Tooltip>
          ),

          Positiva: (
            <Tooltip title="Positiva">
              <CancelIcon className="color-red" />
            </Tooltip>
          ),
          PositivaaVencer: (
            <Tooltip title="Positiva a vencer">
              <AccessAlarmsIcon className="color-red" />
            </Tooltip>
          ),
          PositivaVencida: (
            <Tooltip title="Positiva vencida">
              <EventBusyIcon className="color-red" />
            </Tooltip>
          ),
        };

        const optionsStatusShow = [];

        try {
          setLoadingData(true);

          const { data: cndNegative } = await findCNDConfig(
            queryParams.empresa_cnpj,
            "acesso_cnd_negativa"
          );

          const { data: cndPositive } = await findCNDConfig(
            queryParams.empresa_cnpj,
            "acesso_cnd_positiva"
          );

          if (cndNegative && cndNegative.value) {
            optionsStatusShow.push("Negativa", "Positiva Negativa");
          }

          if (cndPositive && cndPositive.value) {
            optionsStatusShow.push("Positiva");
          }

          const { data } = await findCNDAgendaCliente(
            queryParams.empresa_cnpj,
            idCliente
          );

          if (data && Array.isArray(data)) {
            dataRowsCopy = [...data];
          }
        } catch (error) {
          notify("Não foi possível obter os dados.");
          console.error(
            "error useEffect CNDTabControleCliente findCNDAgendaCliente 1",
            error
          );
        } finally {
          setLoadingData(false);
        }

        dataRowsCopy.forEach((row, index) => {
          row.cnds = row.cnds
            ? row.cnds.filter((i) => optionsStatusShow.includes(i.status))
            : [];

          row.total = row.cnds.length;

          row.cnds.forEach((rowSub) => {
            rowSub.icon = optionsIcons[rowSub.status + (rowSub.situacao || "")];
            rowSub.status =
              rowSub.status === "Positiva Negativa"
                ? "Negativa"
                : rowSub.status;
            rowSub.ambito = rowSub.agenda.ambito;
            rowSub.consulta = rowSub.agenda.tipo_consulta;
            rowSub.cnd = rowSub.agenda.cnd.cnd;
            rowSub.data_emissao = rowSub.data_emissao
              ? rowSub.data_emissao.split("-").reverse().join("/")
              : "";
            rowSub.data_vencimento = rowSub.data_vencimento
              ? rowSub.data_vencimento.split("-").reverse().join("/")
              : "";

            rowSub.acoes = (
              <div className="min-width-actions">
                <Tooltip title="Abrir em outra aba">
                  <VisibilityIcon
                    disabled={rowSub.file_base64 ? false : true}
                    className="icon-action-with-margin"
                    onClick={() => showFile(rowSub.file_base64)}
                  />
                </Tooltip>

                <Tooltip title="Download">
                  <CloudDownloadIcon
                    disabled={rowSub.file_base64 ? false : true}
                    className="icon-action-with-margin"
                    onClick={() => downloadFile(rowSub.file_base64)}
                  />
                </Tooltip>
              </div>
            );
          });

          row.cnpj_cpf = MaskService.toMask("cnpj", row.cnpj_cpf);

          row.acoes = (
            <div className="min-width-actions">
              <Tooltip title="Abrir em outra aba">
                <VisibilityIcon
                  className="icon-action-with-margin"
                  onClick={() => mapAllFiles(row.cnds, "show")}
                />
              </Tooltip>

              <Tooltip title="Download">
                <CloudDownloadIcon
                  className="icon-action-with-margin"
                  onClick={() => mapAllFiles(row.cnds, "download")}
                />
              </Tooltip>
            </div>
          );

          if (row.cnds && row.cnds.length > 0) {
            row.subitemTable = (
              <TableDefault
                key={index}
                columns={columnsSubitem}
                tableTitle=""
                values={row.cnds.sort((a, b) => a.id - b.id)}
                rowsPerPage={rowsPerPage}
              />
            );
          } else {
            row.subitemTable = <label>Não há registros</label>;
          }
        });

        setDataRows(dataRowsCopy);
      };

      constructorRows();
    } catch (error) {
      notify("Não foi possível construir a tela.");
      console.error("error useEffect CNDTabControleCliente 2");
    }
  }, [
    rowsPerPage,
    queryParams.empresa_cnpj,
    queryParams.id_cliente,
    refreshData,
    idCliente,
    access,
  ]);

  return (
    <>
      <TableDefault
        loading={loadingData}
        columns={defaultTableColumns}
        tableTitle={
          <div className="container-checkbox-controle">
            Controle de todas as CNDs cadastradas
            <Grid
              container
              direction="row"
              justify="flex-end"
              alignItems="center"
              spacing={4}
            >
              <Grid item flex={1}>
                <Grid item container justify="center">
                  <Button
                    variant="contained"
                    color="primary"
                    style={{ marginTop: 15, marginBottom: 15, width: "100%" }}
                    startIcon={<RefreshIcon />}
                    onClick={() => window.location.reload()}
                  >
                    Atualizar Status das Consultas
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </div>
        }
        values={dataRows}
        subitemTable={!loadingData}
        initialSubitemOpen={0}
        rowsPerPage={rowsPerPage}
      />
    </>
  );
};

export default CNDTabControleCliente;
